<template>
    <v-card-actions
        id="step-footer"
        class="pa-0"
    >
        <v-container class="pa-0">
            <v-divider/>
            <div
                class="d-flex align-stretch px-6 py-4"
                :class="{
                    'justify-end': currentStep === 1,
                    'justify-center': currentStep > 1
                }"
            >
                <template v-if="isDownloadStep">
                    <v-btn
                        v-if="false"
                        class="dark-text text-none text-decoration-underline habiteo-body-1 pa-4"
                        :elevation="0"
                        x-large
                        :width="100"
                        color="transparent"
                        :ripple="false"
                    >
                        {{ $t('habiteoStudio.exportHistory') }}
                    </v-btn>

                    <v-btn
                        color="green darken-1"
                        class="white--text text-none habiteo-body-1 pa-4"
                        :elevation="0"
                        x-large
                        :width="150"
                        :ripple="false"
                        @click.stop="resetForm"
                    >
                        {{ $t('habiteoStudio.newExport') }}
                    </v-btn>
                </template>
                <template v-else-if="isDownloading">
                    <v-btn
                        class="dark-text text-none text-decoration-underline habiteo-body-1"
                        :elevation="0"
                        large
                        block
                        color="transparent"
                        :ripple="false"
                        @click.stop="cancelExport"
                    >
                        {{ $t('utils.cancel') }}
                    </v-btn>
                </template>
                <template v-else>
                    <v-btn
                        v-if="currentStep > 1"
                        class="dark-text text-none text-decoration-underline habiteo-body-1 pa-2"
                        :elevation="0"
                        :width="180"
                        :height="50"
                        color="transparent"
                        :ripple="false"
                        @click.prevent="!isExportStep ? previousStep() : goBackSummary()"
                    >
                        {{ $t('utils.previous') }}
                    </v-btn>

                    <v-btn
                        v-if="step.id !== 'step_5'"
                        :color="stepIsFilled ? 'green darken-1' :'green lighten-4'"
                        class="text-none habiteo-body-1 pa-2"
                        :class="{
                            'white--text': stepIsFilled,
                            'green-text text-darken-1 disabled-cta': !stepIsFilled,
                        }"
                        :elevation="0"
                        :width="180"
                        :height="50"
                        :ripple="false"
                        @click.prevent="!isEditingStep ? nextStep() : goBackSummary()"
                    >
                        {{ $t('utils.next') }}
                    </v-btn>
                    <v-btn
                        v-else-if="!isExportStep"
                        color="green darken-1"
                        class="white--text text-none habiteo-body-1"
                        :elevation="0"
                        :width="180"
                        :height="50"
                        :ripple="false"
                        @click.prevent="submitSummary"
                    >
                        <v-icon left>
                            icon-eye-opened
                        </v-icon>
                        {{ $t('habiteoStudio.adjustView') }}
                    </v-btn>
                    <v-btn
                        v-else
                        color="green darken-1"
                        class="white--text text-none habiteo-body-1"
                        :elevation="0"
                        :width="180"
                        :height="50"
                        :ripple="false"
                        @click.prevent="startExport"
                    >
                        <v-icon left>
                            icon-download-file
                        </v-icon>
                        {{ $t('habiteoStudio.export') }}
                    </v-btn>
                </template>
            </div>
        </v-container>
    </v-card-actions>
</template>

<script>
    export default {
        name: 'StepFooter',
        props: {
            currentStep: {
                type: Number,
                required: true
            },
            isDownloading: {
                type: Boolean,
                required: true
            },
            isExportStep: {
                type: Boolean,
                required: true
            },
            isDownloadStep: {
                type: Boolean,
                required: true
            },
            isEditingStep: {
                type: Boolean,
                required: true
            },
            maxStep: {
                type: Number,
                required: true
            },
            step: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                skippedFields: {'step_3': ['advanced_preset']}
            }
        },
        computed: {
            fieldsToFill() {
                let fields = {};
                if (this.$props.step) {
                    this.$props.step.forms.forEach(form => {
                        form.inputs.forEach(input => {
                            if(this.skippedFields[this.$props.step.id] && this.skippedFields[this.$props.step.id].includes(input.id)) {
                                return;
                            }
                            fields[input.id] = input.value;
                        })
                    });
                    return fields;
                } else
                    return null;
            },
            stepIsFilled() {
                let status = true;
                Object.keys(this.fieldsToFill).forEach(key => {
                    if (this.fieldsToFill[key] === null)
                        status = false;
                });
                return status;
            }
        },
        methods: {
            goBackSummary() {
                this.$emit('go-back-summary');
            },
            submitSummary() {
                this.$emit('submit-summary');
            },
            startExport() {
                this.$emit('start-export');
            },
            nextStep() {
                this.$emit('next-step');
            },
            previousStep() {
                this.$emit('previous-step');
            },
            cancelExport() {
                this.$emit('cancel-export');
            },
            resetForm() {
                this.$emit('reset-form');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/StepFooter.vue